import { useRef, type FC, type SyntheticEvent } from 'react';
import ReactPlayer from 'react-player';
import { resolveMediaUrl } from '../api/client';
import { HlsVideo } from './HlsVideo';
import { BunnyVideo } from './BunnyVideo';
import { VideoUnavailable } from './VideoUnavailable';

const VIDEO_STYLE: React.CSSProperties = {
  width: '100%',
  height: 210,
  background: '#000',
  borderRadius: 'var(--radius-md)',
};

/**
 * Tahlil videosi — sahifaning OʻZIDA, dars videosi kabi.
 *
 * NEGA HAVOLA EMAS: ilgari bu `<a target="_blank" rel="noreferrer">`
 * edi va ishlamasdi, ikki sabab bilan birdaniga:
 *
 *  1. Bunny videosi uchun server `.m3u8` oqim srcini beradi. Uni
 *     Chrome oʻzi ijro eta olmaydi — hls.js kerak, u esa faqat
 *     bizning sahifamizda bor.
 *  2. Bunny kutubxonasi CDN'ga kirishni REFERRER boʻyicha toʻsadi
 *     (CLAUDE.md §3.6): referrer yoʻq -> 403. `noreferrer` aynan uni
 *     olib tashlardi.
 *
 * Telegram ichida yangi oyna ochish ham ishonchsiz. Shuning uchun
 * manba turi dars ekranidagi bilan BIR XIL aniqlanadi.
 *
 * Koʻrish foizi talab emas, lekin yiqilgan urinishdan keyin tahlilni
 * koʻrgan oʻquvchi kutmasdan qayta topshiradi (`RetryWait.tsx`): 80% ga
 * yetganda `onWatched` BIR MARTA chaqiriladi. Soniyalar takrorlanmay
 * sanaladi — oxiriga surib qoʻyish hisob emas. Server baribir oʻzi qaror qiladi.
 */
const WATCHED_PERCENT = 80;

export const AnalysisVideo: FC<{
  url: string | null | undefined;
  /** Video Bunny'da, Bunny esa hozir ishlamayapti. */
  unavailable?: boolean;
  onWatched?: (percent: number) => void;
}> = ({ url, unavailable, onWatched }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const seen = useRef(new Set<number>());
  const reported = useRef(false);
  const track = (current: number, duration: number) => {
    if (!onWatched || reported.current) return;
    if (!duration || !Number.isFinite(duration)) return;
    seen.current.add(Math.floor(current));
    const percent = Math.floor((seen.current.size / duration) * 100);
    if (percent >= WATCHED_PERCENT) {
      reported.current = true;
      onWatched(Math.min(100, percent));
    }
  };
  const onTimeUpdate = (e: SyntheticEvent<HTMLVideoElement>) =>
    track(e.currentTarget.currentTime, e.currentTarget.duration);
  const src = resolveMediaUrl(url);
  if (!src) return unavailable ? <VideoUnavailable /> : null;

  if (src.includes('.m3u8')) {
    return (
      <HlsVideo
        src={src}
        videoRef={videoRef}
        style={VIDEO_STYLE}
        onTimeUpdate={onTimeUpdate}
      />
    );
  }
  if (src.includes('mediadelivery.net')) {
    return (
      <BunnyVideo
        src={src}
        onProgress={(p) =>
          p.played > 0 && track(p.playedSeconds, p.playedSeconds / p.played)
        }
      />
    );
  }
  if (src.startsWith('/') || src.toLowerCase().endsWith('.mp4')) {
    return (
      <video
        src={src}
        controls
        playsInline
        controlsList="nodownload"
        style={VIDEO_STYLE}
        onTimeUpdate={onTimeUpdate}
      />
    );
  }
  return (
    <ReactPlayer
      src={src}
      controls
      width="100%"
      height="210px"
      playsInline
      onTimeUpdate={onTimeUpdate as any}
    />
  );
};
